import { useCallback } from 'react';

import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { CreatePraiseInput, DeletePraiseInput, UpdatePraiseInput } from '@/types/schema';

import { useCreatePraiseMutation } from '../../graphql/mutations/generated/createPraise';
import { useDeletePraiseMutation } from '../../graphql/mutations/generated/deletePraise';
import { useUpdatePraiseMutation } from '../../graphql/mutations/generated/updatePraise';

const usePraiseMutations = () => {
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();
  const [{ fetching }, executeUpdatePraise] = useUpdatePraiseMutation();
  const [, executeCreatePraise] = useCreatePraiseMutation();
  const [, executeDeletePraise] = useDeletePraiseMutation();

  const onCreatePraise = useCallback(
    async (input: CreatePraiseInput) => {
      const response = await executeCreatePraise({ input });

      if (response.error) {
        showDefaultErrorSnackbar();
      }
      return { response };
    },
    [executeCreatePraise, showDefaultErrorSnackbar],
  );

  const onUpdatePraise = useCallback(
    async (input: UpdatePraiseInput) => {
      const response = await executeUpdatePraise({ input });

      if (response.error) {
        showDefaultErrorSnackbar();
      }
      return { response };
    },
    [executeUpdatePraise, showDefaultErrorSnackbar],
  );

  const onDeletePraise = useCallback(
    async (input: DeletePraiseInput) => {
      const response = await executeDeletePraise({ input });

      if (response.error) {
        showDefaultErrorSnackbar();
      }
      return { response };
    },
    [executeDeletePraise, showDefaultErrorSnackbar],
  );

  return { fetching, onCreatePraise, onUpdatePraise, onDeletePraise };
};

export default usePraiseMutations;
